import { InspectionEvent, Observer } from 'xstate'

// Late-bound seam for the xstate inspector. `@statelyai/inspect` is ESM-only and dev-only, so
// `AppWrapper` loads it with a dynamic import and registers the handler here; `FSMService`
// forwards inspection events through `forwardInspection` without importing the package. Keeps
// the inspector out of both the production bundle and jest's CJS module graph.
//
// The handler attaches after boot, so the inspector does not see the machine's initial events.
type InspectHandler = Observer<InspectionEvent> | ((event: InspectionEvent) => void)

let handler: InspectHandler | undefined

export const setInspectHandler = (nextHandler: InspectHandler): void => {
  handler = nextHandler
}

export const forwardInspection = (event: InspectionEvent): void => {
  if (!handler) return

  // `createBrowserInspector().inspect` is an Observer; a plain callback is also accepted.
  typeof handler === 'function' ? handler(event) : handler.next?.(event)
}
